// PROD-9977: concierge_bucket restarts a bucket episode after 35 days as a BUCKET_CHANGE row with
// from_bucket === to_bucket (reason_tag BUCKET_RESTART_35D); without a note it reads "X → X".
export const BUCKET_RESTART_NOTE = 'Restarted after 35 days';

export const bucket_restart_note = (row) => {
  if (!row || row.event_type !== 'BUCKET_CHANGE') return '';
  if (row.reason_tag === 'BUCKET_RESTART_35D') return BUCKET_RESTART_NOTE;
  return row.from_bucket && row.from_bucket === row.to_bucket ? BUCKET_RESTART_NOTE : '';
};
